<template>
  <main>
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section id="home_user_info">
      <div class="flex-row usr_home">
        <div class="left_usr_home">
          <div class="flex-row row1">
            <p class="salutation">{{ getTranslations.home_home_salutation }}</p>
          </div>
          <div class="flex-row row2">
            <div class="user_img_bg">
              <base-avatar-image :src="userDetails.avatar"></base-avatar-image>
            </div>

            <p class="name">{{ userDetails.username }}</p>
          </div>
          <div class="flex-row row3">
            <div class="lvl_badge flex-row" @click.prevent="showLevelModal">
              <img :src="getLevelBadge" alt="avatar of user">
              <p>{{ getTranslations.home_home_level }} {{ userDetails.level }}</p>
            </div>
            <div class="bg_border points_no_click">
              <div class="flex-row">
                <img src="/static/images/home/points_star.png" class="points_img_anim">
                <p>{{ userDetails.totalPointsEarned }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="home_games_left">
      <div v-if="userDetails.availableGames > 0" class="box">
        <p class="title"><span>{{ userDetails.availableGames }}</span>
          <span @click="navigateToGameIntro"
                style="cursor: pointer; text-decoration: underline;">
                {{ getTranslations.home_home_available_games }}
        </span></p>
        <p class="points">{{ pointsToEarn }} {{ getTranslations.home_home_generic_text }}</p>

        <div class="outline_fancy_btn play"> <!-- TO-DO Game Functionality-->
          <button type="" @click="navigateToGameIntro" class="fancy_btn"> {{ getTranslations.home_play_game }} </button>
<!--          <div class="button" @click="playGame"><a style="cursor: pointer" class="play_game"> {{ getTranslations.home_play_game }} </a></div>-->
        </div>
        <div v-if="!hideStore" @click.prevent="toStorePage" class="flex-row">
            <img src="/static/images/home/more_quizes_icon.png">
            <p class="get_more_quiz"> {{ getTranslations.home_buy_games }} </p>
        </div>
      </div>

      <div v-else class="box">
        <p class="title"><span>{{ userDetails.availableGames }}</span>
          <span @click="toStorePage"
                style="cursor: pointer; text-decoration: underline;">
                {{ getTranslations.home_home_available_games }}
          </span></p>
        <p class="points">{{ userDetails.availableGames * 300 }} {{ getTranslations.home_home_generic_text }} </p>

        <div class="outline_fancy_btn play inactive">
          <button type="" class="fancy_btn"> {{ getTranslations.home_play_game }}</button>
        </div>
        <div v-if="!hideStore" @click.prevent="toStorePage" class="outline_fancy_btn more_quizes_btn">
          <button type="" class="fancy_btn">{{ getTranslations.home_buy_games }}</button>
        </div>
      </div>
    </section>
<!-- TO-DO PHASE 1.1 invite >-->

<!--    <section id="home_invite">-->
<!--      <div class="box flex-row">-->
<!--        <div class="flex-column col1">-->
<!--          <img src="/static/images/home/invite.png">-->
<!--        </div>-->
<!--        <div class="flex-column col2">-->
<!--          <p class="heading">Invite Friends</p>-->
<!--          <p class="text">Invite Your Friends, Earn Points, and Redeem Exciting Rewards!</p>-->
<!--        </div>-->
<!--        <div class="flex-column col3">-->
<!--          <i class="fas fa-chevron-right"></i>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <prize-section></prize-section>

    <section v-if="phaseBonusList.length > 0" class="bonus_phases">
      <home-bonus-phase-item
        v-for="bonusPhase in phaseBonusList"
        :key="bonusPhase.id"
        :bonus-phase="bonusPhase"
        @bonusPhase:expired="handleBonusPhaseExpiration"
      ></home-bonus-phase-item>
    </section>

    <resume-game-modal v-if="isResumeGameModalOpen" @resume:game="handleResumeGame"></resume-game-modal>

    <pre-game-modal v-if="isPreGameModalOpen" @close:modal="isPreGameModalOpen = false"></pre-game-modal>

    <pre-lantern-game-modal
      v-if="addOnGamePreModalConfiguration.isLanternOpen"
      :can-play="addOnGamePreModalConfiguration.canPlay"
      @play:lantern="handlePlayLanternGame"
    />

    <pre-puzzle-game-modal
      v-if="addOnGamePreModalConfiguration.isPuzzleOpen"
      :can-play="addOnGamePreModalConfiguration.canPlay"
      @play:puzzle="handlePlayPuzzleGame"
    />

    <level-up
      v-if="levelUpConfiguration.open"
      :level="levelUpConfiguration.level"
      :reward-points="levelUpConfiguration.rewardPoints"
      @redirect:levelsPage="redirectToLevelsPageFromLevelUpModal"
    ></level-up>
  </main>

</template>

<script>
  /* eslint no-console: "off" */
  import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import { closeBanner } from '@/common/jQuery';
import 'owl.carousel';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import executionChainMixin from '../../common/mixins/executionChain';
import modals from '@/common/modals';
import ResumeGameModal from './modals/ResumeGameModal';
import PreGameModal from './modals/pregame/PreGameModal';
import UnlockedGamesModal from './modals/unlockedgames/UnlockedGamesModal';
import UnlockedGamesZeroBalanceModal from './modals/unlockedgames/UnlockedGamesZeroBalanceModal';
import PrizeSection from '../common/section/PrizeSection';
import BonusBox from './BonusBox';
import BonusBoxMobile from './BonusBoxMobile';
import GamesCarouselMobile from './GamesCarouselMobile';
import AchievementsProfile from './profile/AchievementsProfile';
import LevelUp from './modals/LevelUp';
import LevelModal from "./modals/LevelModal";
import {removeLocalStorageValueByUser} from '../../helpers/user';
import BaseAvatarImage from '../common/image/BaseAvatarImage';
import HomeBonusPhaseItem from './HomeBonusPhaseItem'
import PreLanternGameModal from '../common/modal/game/PreLanternGameModal.vue';
import PrePuzzleGameModal from '../common/modal/game/PrePuzzleGameModal.vue';



export default {
  name: 'default-content',
  props: ['playGame'],
  components: {
    PrePuzzleGameModal,
    PreLanternGameModal,
    BaseAvatarImage,
    ResumeGameModal,
    AchievementsProfile,
    GamesCarouselMobile,
    BonusBox,
    UnlockedGamesZeroBalanceModal,
    UnlockedGamesModal,
    PreGameModal,
    PrizeSection,
    BonusBoxMobile,
    LevelUp,
    LevelModal,
    HomeBonusPhaseItem,
  },
  data() {
    return {
      isMobileDevice: false,
      isResumeGameModalOpen: false,
      isPreGameModalOpen: false,
      addOnGamePreModalConfiguration: {
        isLanternOpen: false,
        isPuzzleOpen: false,
        canPlay: false,
      },
      levelUpConfiguration: {open: false, level: null, rewardPoints: null},
      bonusPhase: {POINTS: {expired: false}}
    };
  },
  mixins: [NumbersFormattingMixin, executionChainMixin],
  beforeDestroy() {
    this.setBonusPhasesNum(this.phaseBonusList.length);
  },
  mounted () {
    closeBanner();
  },
  created() {
    this.executionChainMixinSetMethodList([
      this.checkIsGameInProgress,
      () => {
        this.getUserLoginDetails().then(()=>{
          this.checkLevelUp();
        });
      },
      this.checkAddOnGame,
    ]);

    this.executionChainController.launch();
  },
  methods: {
    ...mapMutations('game', [
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
      'setAddOnGameConfig',
    ]),
    ...mapMutations('profile', [
      'setBonusPhasesNum',
      'setIsAddonGameModalShown'
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails'
    ]),
    ...mapActions('game', [
      'getAddOnGameStatus',
    ]),
    checkIsGameInProgress () {
      if (localStorage.getItem('isGameInProgress')) {
        const isGameInProgress = removeLocalStorageValueByUser('isGameInProgress', this.userDetails.msisdn);

        if (isGameInProgress) {
          this.isResumeGameModalOpen = true;

          modals.setupCommonModal({
            afterHideCallback: () => {
              this.isResumeGameModalOpen = false;

              this.executionChainController.next()
            }
          })

          return;
        }
      }

      this.executionChainController.next();
    },
    checkLevelUp () {
      if (localStorage.getItem('levelUp')) {
        const currentUserLevelUpInfo = removeLocalStorageValueByUser('levelUp', this.userDetails.msisdn)

        if (currentUserLevelUpInfo) {
          this.levelUpConfiguration.level = currentUserLevelUpInfo.level
          this.levelUpConfiguration.rewardPoints = currentUserLevelUpInfo.rewardPoints
          this.levelUpConfiguration.open = true

          modals.setupCommonModal({
            afterHideCallback: () => {
              this.resetLevelUpConfiguration()

              this.executionChainController.next()
            }
          })

          return;
        }
      }

      this.executionChainController.next();
    },
    async checkAddOnGame () {
      if (
        (this.lanternGame || this.puzzleGame) &&
        !this.isAddOnGameModalShown
      ) {
        this.setIsAddonGameModalShown(true);

        let gameId = null;

        if (this.lanternGame) {
          gameId = this.lanternGame.id;
        } else if (this.puzzleGame) {
          gameId = this.puzzleGame.id;
        }

        try {
          const queryParams = {
            gameId,
            msisdn: this.userDetails.msisdn,
          };

          const addOnGameStatusResponse = await this.getAddOnGameStatus({ queryParams });

          this.addOnGamePreModalConfiguration.canPlay = addOnGameStatusResponse.canPlay;
        } catch (_e) {
          this.executionChainController.next();

          return;
        }

        if (this.lanternGame) {
          this.addOnGamePreModalConfiguration.isLanternOpen = true;

          modals.setupCommonModal({
            afterHideCallback: () => {
              this.addOnGamePreModalConfiguration.isLanternOpen = false;
              this.addOnGamePreModalConfiguration.canPlay = false;

              this.executionChainController.next();
            },
          });

          return;
        } else if (this.puzzleGame) {
          this.addOnGamePreModalConfiguration.isPuzzleOpen = true;

          modals.setupCommonModal({
            afterHideCallback: () => {
              this.addOnGamePreModalConfiguration.isPuzzleOpen = false;
              this.addOnGamePreModalConfiguration.canPlay = false;

              this.executionChainController.next();
            },
          });

          return;
        }
      }

      this.executionChainController.next();
    },
    handlePlayLanternGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.addOnGamePreModalConfiguration.isLanternOpen = false;
          this.addOnGamePreModalConfiguration.canPlay = false;

          this.setAddOnGameConfig({ gameId: this.lanternGame.id });

          this.$router.push({ name: 'addOnGameLantern' });
        },
      });
    },
    handlePlayPuzzleGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.addOnGamePreModalConfiguration.isPuzzleOpen = false;
          this.addOnGamePreModalConfiguration.canPlay = false;

          this.setAddOnGameConfig({
            gameId: this.puzzleGame.id,
            prizeValue: this.puzzleGame.rewardPoints,
          });

          this.$router.push({ name: 'addOnGamePuzzle' });
        },
      });
    },
    handleResumeGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.isResumeGameModalOpen = false;

          this.navigateToGameIntro();
        }
      });
    },
    formattedValue(intValue) {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        return intValue.toLocaleString();
      }
      return intValue;
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    openUnlockedModal() {
      if (this.userDetails.availableGames !== 0) this.storeModalForHomePage(UnlockedGamesModal);
      else this.storeModalForHomePage(UnlockedGamesZeroBalanceModal);
      modals.showHideModal(this);
    },
    showLevelModal() {
      this.storeModalForHomePage(LevelModal);
      modals.showHideModal(this);
    },
    navigateToGameIntro() {
      this.isPreGameModalOpen = true;
    },
    resetLevelUpConfiguration () {
      this.levelUpConfiguration.open = false;
      this.levelUpConfiguration.level = null;
      this.levelUpConfiguration.rewardPoints = null;
    },
    redirectToLevelsPageFromLevelUpModal () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.resetLevelUpConfiguration();

          this.$router.push('/home/levels');
        }
      })
    },
    handleBonusPhaseExpiration ({type}) {
      if (type === 'POINTS') {
        this.bonusPhase.POINTS.expired = true
      }
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
      'availableIntegrations',
      'integrationHeader',
      'hideStore',
      'hideJackpot',
      'userDetails',
      'connectionPoints',
      'facebookFunctionality',
      'showOptOutPhase',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapState('profile', [
      'phaseBonusList',
      'bonusPhasesNum',
      'lanternGame',
      'puzzleGame',
      'isAddOnGameModalShown',
    ]),
    getLevelBadge() {
      const level = Math.min(this.userDetails.level, 4); // Ensures level doesn't exceed 4
      return `/static/images/levels/badges/lvl${level}_icon.png`;
    },
    pointsToEarn () {
      let points = this.userDetails.availableGames * 3 * 50 // Calculate total potential points to earn from available games (3 rounds per game, 50 points per round)

      if (!this.bonusPhase.POINTS.expired && Array.isArray(this.phaseBonusList) && (this.phaseBonusList.length > 0)) {
        const bonusPhaseGamePointsInfo = this.phaseBonusList.find(({type}) => type === 'POINTS')
        if (bonusPhaseGamePointsInfo) {
          points *= bonusPhaseGamePointsInfo.multiplier
        }
      }

      return points
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue